import { LocationStrategy } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@cmps/ng-bootstrap';

import { navigateForLink, NavigationSrc } from './navigate';
import { NotificationPanelService } from './notification-panel.service';
import { TranslationKeyMap } from './notification.i18n';
import {
    Notification,
    NotificationLink,
    ViewModel,
} from './notification.model';

@Component({
    selector: 'cmps-notification-modal',
    templateUrl: './modal.notification.component.html',
})
export class ModalNotificationComponent {
    i18n = TranslationKeyMap;
    vm: ViewModel;

    constructor(
        private readonly _router: Router,
        private readonly _locationStrategy: LocationStrategy,
        private readonly _activeModal: NgbActiveModal,
        private readonly _panelService: NotificationPanelService,
    ) {
        this.vm = new ViewModel();
    }

    onLinkClick($event: NotificationLink): void {
        navigateForLink(
            this._locationStrategy,
            this._router,
            $event,
            NavigationSrc.NOTIFICATION_ALERT,
            true,
        );
    }

    onAcknowledgeClick(notification: Notification): void {
        this._panelService.markAsRead(notification);
        this._panelService.markAsAcknowledged(notification);
        this.vm.notificationAcks[notification.id] = true;
        if (
            Object.keys(this.vm.notificationAcks).length ===
            this.vm.notifications.length
        ) {
            // TODO revise. closing before requests complete
            this._activeModal.close();
        }
    }
}
